import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableHead, TableRow, Grid, Tooltip, IconButton } from '@mui/material';
import EngineScoringClassificationAttributeListItemComponent from './EngineScoringClassificationAttributeListItemComponent';
import { Add } from '@mui/icons-material';
import { getErrors } from '@totalsoft/pure-validations-react';
import { Typography } from '@totalsoft/rocket-ui';

const EngineScoringClassificationAttributeListComponent = ({
  attributes,
  engineClassificationIndex,
  isReadOnly,
  dispatch,
  validation,
  engineAttributeOptions
}) => {
  const { t } = useTranslation();
  const onAddNewAttribute = () => {
    dispatch({
      type: 'OnAddNewClassificationAttribute',
      classificationIndex: engineClassificationIndex
    });
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('EngineScoring.EngineClassifications.EngineAttribute.OrderNo')}</TableCell>
              <TableCell>{t('EngineScoring.EngineClassifications.EngineAttribute.AttributeName')}</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {attributes.map((item, idx) => {
              return (
                <EngineScoringClassificationAttributeListItemComponent
                  key={idx}
                  attribute={item}
                  dispatch={dispatch}
                  attributeIndex={idx}
                  classificationIndex={engineClassificationIndex}
                  engineAttributeOptions={engineAttributeOptions}
                  validation={validation[idx]}
                  isReadOnly={isReadOnly}
                />
              );
            })}
          </TableBody>
        </Table>
      </Grid>
      <Grid item xs={11}>
        <Typography color='error'>{validation |> getErrors}</Typography>
      </Grid>
      <Grid item xs={1} sx={{ textAlign: 'right' }}>
        <Tooltip title={t('Tooltips.EngineScoringGrid.Add')}>
          <span>
            <IconButton onClick={onAddNewAttribute} color='primary' disabled={isReadOnly}>
              <Add />
            </IconButton>
          </span>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

EngineScoringClassificationAttributeListComponent.propTypes = {
  attributes: PropTypes.array.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  engineAttributeOptions: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  engineClassificationIndex: PropTypes.number.isRequired,
  validation: PropTypes.object.isRequired
};

export default EngineScoringClassificationAttributeListComponent;
